// extracted by mini-css-extract-plugin
module.exports = {"brand":"FlexGrid_brand__3jl5w","spinAround":"FlexGrid_spinAround__3w1ao"};